import { blue ,grey } from '@mui/material/colors';

export default {
    root: {
        boxShadow: 'none',
        color: blue['700'],
        backgroundColor: grey['50']
  }
};
